"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.focus = void 0;

var _tokens = require("./tokens");

var focus = {
  styles: function styles(_ref) {
    var target = _ref.target,
        shadow = _ref.shadow;
    return {
      outline: 'none',
      boxShadow: (0, _tokens.generateTokenFn)({
        target: target,
        tokenKey: 'shadow',
        type: 'shadow',
        fallback: shadow,
        base: function base(_ref2) {
          var token = _ref2.token;
          return token('shadow.focus');
        }
      })
    };
  },
  tokens: function tokens(_ref3) {
    var target = _ref3.target,
        shadow = _ref3.shadow;
    return {
      shadow: (0, _tokens.generateTokenFn)({
        target: target,
        tokenKey: 'shadow',
        type: 'shadow',
        fallback: shadow,
        base: function base(_ref4) {
          var token = _ref4.token;
          return token('shadow.focus');
        }
      })
    };
  }
};
exports.focus = focus;